String.prototype.ftuc = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.camelize = function() {
  return this.replace(/_/g, ' ').replace(/\w+/g, (match, index) => {
    return (index > 0) ? match.ftuc() : match;
  }).replace(/(-|_|\s)/g, '');
};

String.prototype.decamelize = function(separator = '_') {
  return this
    .replace(/[^\w\s]/ig, '')
    .replace(/ /g, `${separator}`)
    .replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`)
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, `$1${separator}$2`)
    .toLowerCase();
};

String.prototype.compact = function(length = 10, indicator = '...') {
  return (this.length > length)
    ? `${this.substring(0, length - indicator.length)}${indicator}`
    : this;
};

String.prototype.format = function() {
  return 'NaN'; // it is trying to format a non valid number
};

String.prototype.sTrim = function(exp=/(\r\n|\n|\r)/gm) {
  // super trim
  return this?.trim()?.replace(exp, '');
};

export default String;
